import React, { useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate} from 'react-router-dom';
import { mobileRoutes } from '../routes/mobileRoutes';
import DataManager from '../components/global/DataManager/Datamanager'
import { WebSocketProvider } from '../context/WebSocketContext';
import { setGlobalSymbolsData } from '../store/Slices/globalSymbolSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@emotion/react';
import AcceptReject from '../components/modal/AcceptReject/AcceptReject';
const MobileLayout = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const DefaultComponent = mobileRoutes[0].component;
    const { symbols } = useSelector(state => state.watchlist)
    const { userDetail } = useSelector(state => state.user);
    const dispatch = useDispatch();
    const id = userDetail?.id
    const currentTab = mobileRoutes.findIndex(route => route.path === location.pathname);
    const data = Object.values(symbols).filter(symbol => symbol.isVisible && symbol.isUsed);
    const hiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    const { globalSymbol } = useSelector(state => state?.globalSymbol)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        if (data && data.length > 0) {
            if (globalSymbol?.id) return;

            const visibleSymbols = hiddenSymbols.length
                ? data.filter(symbol => !hiddenSymbols?.includes(symbol?.id))
                : data;

            if (visibleSymbols.length > 0) {
                const firstSymbol = visibleSymbols[0];
                if (firstSymbol?.id && firstSymbol?.name) {
                    dispatch(setGlobalSymbolsData(firstSymbol));
                }
            }
        }
    }, [data, hiddenSymbols, globalSymbol?.id]);


    return (
        <>
            <div style={{ height: 'calc(100vh - 56px)', overflow: 'hidden' }}>
                {children}
                <AcceptReject />

            </div>
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, overflowX: 'auto' }} elevation={5}>
                <BottomNavigation showLabels value={currentTab !== -1 ? currentTab : 0} onChange={(event, newValue) => { navigate(mobileRoutes[newValue].path); }} sx={{ width: 'max-content', minWidth: '100%' }}>
                    {mobileRoutes.map(({ title, icon, activeIcon, isMenu, path }, index) => (isMenu && <BottomNavigationAction key={index} label={title} icon={location.pathname.startsWith(path) ? activeIcon : icon} />))}
                </BottomNavigation>
            </Paper>
            <DataManager />
            <WebSocketProvider />
        </>
    );
};

export default MobileLayout;
